// extracted by mini-css-extract-plugin
module.exports = {"input":"input_input__C_XcI","label":"input_label__RgVW3","inputContrast":"input_inputContrast__ZsyZq","labelContrast":"input_labelContrast__jcoqv"};